export const queryKeys = {
  base: () => ['settings'] as const,
  backupS3Settings: () => [...queryKeys.base(), 'backupS3Settings'] as const,
  backupAzureSettings: () =>
    [...queryKeys.base(), 'backupAzureSettings'] as const,
  backupLocalSettings: () =>
    [...queryKeys.base(), 'backupLocalSettings'] as const,
  backupLocalStatus: () => [...queryKeys.base(), 'backupLocalStatus'] as const,
};
